import { render, staticRenderFns } from "./tab-dock-location.vue?vue&type=template&id=5fd4514e&"
import script from "./tab-dock-location.vue?vue&type=script&lang=js&"
export * from "./tab-dock-location.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports